import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToHM',
  standalone: false,
})
export class SecondsToHMPipe implements PipeTransform {
  transform(seconds: number) {
    if (!seconds && seconds !== 0) return seconds;

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);

    return `${h.toString().padStart(2, '0')}h ${m.toString().padStart(2, '0')}m`;
  }
}
